import React from 'react'
import styles from './appreciation.scss'
import appreciation from '../../../common/images/solution/appreciation.jpg'
import yd_appreciation from '../../../common/images/solution/yd-appreciation.png'
import one from '../../../common/images/solution/01.png'
import two from '../../../common/images/solution/02.png'
import three from '../../../common/images/solution/03.png'
import four from '../../../common/images/solution/04.png'
import circular from '../../../common/images/solution/circular.png'
import solutions from '../../../common/images/solution/solution.png'
import appreciation_1 from '../../../common/images/solution/appreciation-1.jpg'
import appreciation_2 from '../../../common/images/solution/appreciation-2.jpg'
import appreciation_3 from '../../../common/images/solution/appreciation-3.jpg'
import appreciation_4 from '../../../common/images/solution/appreciation-4.jpg'
import one_x from '../../../common/images/solution/01-x.png'
import two_x from '../../../common/images/solution/02-x.png'
import three_x from '../../../common/images/solution/03-x.png'
import fous_x from '../../../common/images/solution/04-x.png'

const Appreciation = (props) => {
  return <section className={styles['appreciation']}>
    <div className={styles['bill']}>
      <img src={appreciation} alt='appreciation' className={styles['bill_img']} />
      <img src={yd_appreciation} alt='yd_appreciation' className={styles['bg_bill_img']} />
      <div className={styles['bill-content']}>
        <h2>特色增值</h2>
        <p>推动企业前置赋能，助力企业结构数字化再升级。</p>
      </div>
    </div>
    <div className={styles['industry-pain']}>
      <h3>行业痛点</h3>
      <ul>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={one} alt='01' className={styles['industry-one']} /></div>
            <h4>人事信息调取不便</h4>
          </div>
          <div className={styles['industry-p']}>
            <span></span>
            <p>
            人事异动信息滞后，员工信息更新不及时，员工档案、合同调取不便。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={two} alt='02' /></div>
            <h4>代账薪资计算杂</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s2']}></span>
            <p>
            记账人员工资需要逐一计算，工作量大，查看、审批不便利。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={three} alt='03' /></div>
            <h4>印章管理无序</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s3']}></span>
            <p>
            印章管理无序，动向不清，作废印章无登记，埋有隐患。
            </p>
          </div>
        </li>
        <li>
          <div className={styles['industry-h']}>
            <div><img src={four} alt='04' /></div>
            <h4>用车情况无监管</h4>
          </div>
          <div className={styles['industry-p']}>
            <span className={styles['industry-s4']}></span>
            <p>
            车辆里程、保险、维修、汽油等无监控，各类费用杂乱无统计，报销不便。
            </p>
          </div>
        </li>
      </ul>
      <img src={solutions} alt='solutions' className={styles['solutions']} />
      <img src={circular} alt='circular' className={styles['circular']} />
    </div>
    <div className={styles['scheme']}>
      <h3>解决方法</h3>
      <p className={styles['scheme-wz']}>推动企业前置赋能，助力企业结构数字化再升级。</p>
      <div className={styles['scheme_content']}>
        <img src={appreciation_1} alt='appreciation_1' className={styles['gather']} />
        <div>
          <img src={one_x} alt='one-x' className={styles['one-x']} />
          <h4>人事管理</h4>
          <p>
          涵盖员工入职、人事异动（入职、转正、离职）全流程管理，以及合同的全过程管理。人事处理全程数字化，人员档案、异动记录全面展示。
          </p>
        </div>
      </div>
      <div className={`${styles.scheme_content}`}>
        <div className={`${styles.scheme_two}`}>
          <img src={two_x} alt='two-x' className={styles['two-x']} />
          <h4>代账薪资</h4>
          <p>
          记账人员提成工资自动生成，个税数据自动生成，支持工资薪金在线查看、审批，且代账收入自动生成凭证。
          </p>
        </div>
        <img src={appreciation_2} alt='appreciation-2' className={styles['fetch']} />
      </div>
      <div className={styles['scheme_content']}>
        <img src={appreciation_3} alt='appreciation-2' className={styles['print']} />
        <div className={`${styles.scheme_three}`}>
          <img src={three_x} alt='three-x' className={styles['three-x']} />
          <h4>印章管理</h4>
          <p>
          统一印章管理，印章基本信息、保管员、使用信息、使用状态等一目了然，支持用印申请、印章外借申请，实时追踪有迹可循。
          </p>
        </div>
      </div>
      <div className={styles['scheme_content']}>
        <div className={`${styles.scheme_fous}`}>
          <img src={fous_x} alt='fous-x' className={styles['fous-x']} />
          <h4>车辆管理</h4>
          <p>
          支持管理车辆里程、保险、维修、汽油等各项费用，且与报销系统关联；相关费用汇集成表，便于直观查看用车数据。
          </p>
        </div>
        <img src={appreciation_4} alt='appreciation_4' className={styles['ticket']} />
      </div>
    </div>
  </section>
}

export default Appreciation
